import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "./styles";
import { ProviderSiteAdvertisementPopupSummaryDTO } from "../../../../models/provider-site-advertisement-popup-summary/provider-site-advertisement-popup-summary-dto";

const OpenProviderPopupsLink = ({
  customSummary,
  loading,
}: {
  customSummary: ProviderSiteAdvertisementPopupSummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.help_and_tips.open_popups";
  const { t } = useTranslation();
  return (
    <>
      <Container>
        <Typography variant="h4">
          <b> {customSummary.openProviderSiteAdvertisementPopup ?? 0}</b>
        </Typography>
        <Typography>{`${t(`${tRP}`)}`}</Typography>
      </Container>
    </>
  );
};

export default OpenProviderPopupsLink;
